import IGroupersDTO from "src/Interfaces/groupersDTO";

interface IFiltersIndicatorsPanel{
    f: string;
    responsible: string | undefined;
	presentationGroup: string | undefined;
	sector: string | undefined;   
    startDate?: Date | null;
    endDate?: Date | null;
    classification: string | undefined;
    tags: string | undefined;
    level: string | undefined;
    indicatorsId: string | undefined;
    situation: string | undefined;
    map: string | undefined;
    perspective: string | undefined;
    objective: string | undefined;
    budgetPlan: string | undefined;
    currentPeriod: string | undefined;
}

export interface IGroupersIndicators extends IGroupersDTO<IGroupersIndicators>{
    id2: number | null;
    id3: number | null;
    title2: string | null;
    title3: string | null;
    image: string | null;
    imageName: string | null;
    tactic: number;
    operational: number;
    strategic: number;
}

export enum IndicatorShowValues{
    ACCORDING_TO_INDICATOR = "0",
    PERCENT = "1",
    ABSOLUTE_VALUE = "2"
}

export enum IndicatorsGroupers{
    SECTOR = "0",
    SECTOR_RESPONSIBLE = "1",
    RESPONSIBLE = "2",
    MAP = "3",
    MAP_PERSPECTIVE = "4",
    MAP_PERSPECTIVE_OBJECTIVE = "5",
    PRESENTATION_GROUP = "6",
    INDICATOR_CLASSIFICATION = "7",
    INDICATOR_HIERARCHY = "8",
    BUDGET_PLAN = "9",
    LEVEL = "10"
}

export interface IGroupersIndicatorsSelect{
    group: IndicatorsGroupers;
    baseYear: string;
}

export default IFiltersIndicatorsPanel;
